export const storeFeatures = [
  {
    icon: "ri-store-3-line",
    title: "Catálogo de produtos",
    description: "Organize produtos, categorias e variações de forma simples e visual.",
  },
  {
    icon: "ri-shopping-cart-2-line",
    title: "Carrinho e checkout",
    description: "Fluxo de compra pensado para reduzir etapas e facilitar a conversão.",
  },
  {
    icon: "ri-smartphone-line",
    title: "Experiência mobile",
    description: "A loja funciona bem no celular, onde acontece a maior parte das compras.",
  },
  {
    icon: "ri-search-eye-line",
    title: "Otimizada para busca",
    description: "Estrutura de SEO para os produtos serem encontrados no Google.",
  },
  {
    icon: "ri-whatsapp-line",
    title: "Integração com WhatsApp",
    description: "Contato e finalização de pedidos também pelo WhatsApp da empresa.",
  },
  {
    icon: "ri-bar-chart-box-line",
    title: "Gestão e acompanhamento",
    description: "Estrutura preparada para acompanhar pedidos, produtos e resultados.",
  },
];

export const storeTypes = [
  {
    icon: "ri-t-shirt-line",
    title: "Moda e vestuário",
    description: "Lojas com coleções, tamanhos e variações de produto.",
  },
  {
    icon: "ri-plant-line",
    title: "Alimentos e bebidas",
    description: "Catálogos com categorias, pedidos e entregas.",
  },
  {
    icon: "ri-tools-line",
    title: "Casa, construção e peças",
    description: "Grandes catálogos com organização por categoria e marca.",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Saúde e bem-estar",
    description: "Lojas de produtos e serviços com apresentação cuidadosa.",
  },
  {
    icon: "ri-computer-line",
    title: "Eletrônicos e tecnologia",
    description: "Fichas técnicas, variações e comparação de produtos.",
  },
  {
    icon: "ri-handbag-line",
    title: "Cosméticos e acessórios",
    description: "Experiência visual forte para valorizar os produtos.",
  },
];

export const storeSteps = [
  {
    icon: "ri-chat-3-line",
    title: "Planejamento",
    description: "Entendemos os produtos, o público e como a loja precisa vender.",
  },
  {
    icon: "ri-palette-line",
    title: "Design da loja",
    description: "Criamos uma identidade visual que valoriza a sua marca.",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Desenvolvimento",
    description: "Montamos a estrutura com catálogo, carrinho e checkout.",
  },
  {
    icon: "ri-rocket-line",
    title: "Lançamento",
    description: "Colocamos a loja no ar e acompanhamos os primeiros pedidos.",
  },
];

export const lojasFaqs = [
  {
    question: "Quanto tempo leva para criar uma loja virtual?",
    answer:
      "Depende do número de produtos e da complexidade da operação. Após o planejamento, apresentamos um prazo alinhado ao projeto.",
  },
  {
    question: "Consigo gerenciar os produtos depois?",
    answer:
      "Sim. A loja é preparada para que produtos, preços e categorias possam ser atualizados com facilidade.",
  },
  {
    question: "A loja funciona bem no celular?",
    answer:
      "Sim. Desenvolvemos pensando primeiro na experiência mobile, onde acontece a maior parte das compras online.",
  },
  {
    question: "Vocês integram formas de pagamento?",
    answer:
      "Sim. Durante o projeto definimos a forma de pagamento mais adequada ao seu negócio. Fale com um especialista para conhecer as opções.",
  },
  {
    question: "Preciso de hospedagem própria para a loja?",
    answer:
      "A loja precisa de uma estrutura de hospedagem adequada. Se você quiser, reunimos hospedagem, domínio e loja em um só lugar.",
  },
  {
    question: "Quanto custa criar uma loja virtual?",
    answer:
      "O valor depende do número de produtos, das integrações e dos recursos desejados. Depois de entender o seu projeto, apresentamos uma proposta sob medida, sem surpresas.",
  },
  {
    question: "Consigo vender pelo WhatsApp com a loja virtual?",
    answer:
      "Sim. As lojas que criamos podem ter integração com o WhatsApp para tirar dúvidas e finalizar pedidos, além do checkout no próprio site.",
  },
  {
    question: "A loja virtual vem com a minha marca e o meu domínio?",
    answer:
      "Sim. A loja é criada com a identidade visual da sua empresa, no seu domínio (como a sualoja.com.br), e aparece no Google com o seu nome e os seus produtos.",
  },
];